"use strict";
'kiwi public';

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/getPrototypeOf"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IpcBroadcastChannel = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2.default)(IpcBroadcastChannel, _EventEmitter);

  var _super = _createSuper(IpcBroadcastChannel);

  function IpcBroadcastChannel() {
    var _this;

    (0, _classCallCheck2.default)(this, IpcBroadcastChannel);
    _this = _super.call(this);
    _this.bc = new BroadcastChannel('kiwi-ipc');
    _this.bc.onmessage = _this.onmessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(IpcBroadcastChannel, [{
    key: "send",
    value: function send(msg) {
      if (this.bc) {
        this.bc.postMessage(msg);
      }
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      this.emit('message', msg);
    }
  }]);
  return IpcBroadcastChannel;
}(_eventemitter.default);

var IpcLocalStorage = /*#__PURE__*/function (_EventEmitter2) {
  (0, _inherits2.default)(IpcLocalStorage, _EventEmitter2);

  var _super2 = _createSuper(IpcLocalStorage);

  function IpcLocalStorage() {
    var _this2;

    (0, _classCallCheck2.default)(this, IpcLocalStorage);
    _this2 = _super2.call(this);
    window.addEventListener('storage', _this2.onmessage.bind((0, _assertThisInitialized2.default)(_this2)));
    return _this2;
  }

  (0, _createClass2.default)(IpcLocalStorage, [{
    key: "send",
    value: function send(msg) {
      localStorage.setItem('kiwi-ipc', (0, _stringify.default)(msg));
      localStorage.removeItem('kiwi-ipc');
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      if (msg.key === 'kiwi-ipc' && msg.newValue) {
        try {
          var parsedMsg = {
            data: JSON.parse(msg.newValue)
          };
          this.emit('message', parsedMsg);
        } catch (e) {
          this.emit('error');
        }
      }
    }
  }]);
  return IpcLocalStorage;
}(_eventemitter.default);

var _default = window.BroadcastChannel ? new IpcBroadcastChannel() : new IpcLocalStorage();

exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IPC"]
window._kiwi_exports.libs.IPC = exports.default ? exports.default : exports;
